import React from 'react'
import { IBreadcrumbSecondaryItem } from '../common/BreadcrumbSecondaryItem'
import BreadcrumbsSecondary from '../common/BreadcrumbsSecondary'

const WorkplaceBasicsBreadcrumbs = () => {
  const govCMSHome = process.env.REACT_APP_GOVCMS_HOME
  const items: IBreadcrumbSecondaryItem[] = [
    {
      name: 'Home',
      url: govCMSHome,
      index: 1,
    },
    {
      name: 'Tools & resources',
      url: govCMSHome + '/tools-and-resources',
      index: 2,
    },
  ]
  return (
    <>
      <BreadcrumbsSecondary items={items} />
    </>
  )
}

export default WorkplaceBasicsBreadcrumbs
